import { render, staticRenderFns } from "./ntxt.vue?vue&type=template&id=c6084f32&scoped=true"
import script from "./ntxt.vue?vue&type=script&lang=js"
export * from "./ntxt.vue?vue&type=script&lang=js"
import style0 from "./ntxt.vue?vue&type=style&index=0&id=c6084f32&prod&lang=less"
import style1 from "./ntxt.vue?vue&type=style&index=1&id=c6084f32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6084f32",
  null
  
)

export default component.exports